import React, { useRef, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faUser,
  faGlobe,
  faImage,
  faSave,
  faFolderOpen,
} from '@fortawesome/free-solid-svg-icons';

const CreatePartner = () => {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    name: '',
    site: '',
  });

  const [selectedFile, setSelectedFile] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 8 * 1024 * 1024) {
        alert('Le logo ne doit pas dépasser 8 Mo.');
        e.target.value = '';
        return;
      }
      setSelectedFile(file);
    }
  };

  const triggerFileSelect = () => {
    fileInputRef.current.click();
  };

  const onCancel = () => {
    navigate('/admin/partners');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem('token');
      const name = formData.name.trim();
      const site = formData.site.trim();
      const partnersResponse = await axios.get('/partner');
      const existingPartner = partnersResponse.data.find(
        (partner) => partner.name?.trim().toLocaleLowerCase('fr') === name.toLocaleLowerCase('fr'),
      );

      if (existingPartner) {
        const shouldEdit = window.confirm(
          `Le partenaire « ${existingPartner.name} » existe déjà (ID ${existingPartner.id}). Voulez-vous ouvrir sa fiche pour le modifier ?`,
        );
        if (shouldEdit) {
          navigate(`/admin/partners/EditPartner/${existingPartner.id}`);
        }
        return;
      }

      const data = new FormData();
      data.append('name', name);
      data.append('site', site);
      if (selectedFile) {
        data.append('logo', selectedFile);
      }

      await axios.post('/partner', data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      alert('Partenaire créé avec succès !');
      navigate('/admin/partners');
    } catch (err) {
      console.error('Erreur lors de la création :', err.response?.data || err.message);
      const message = err.response?.data?.message
        || (err.request && "Le serveur n'a pas répondu. Vérifiez votre connexion puis réessayez.")
        || err.message
        || "Erreur lors de la création du partenaire.";
      alert(Array.isArray(message) ? message.join(', ') : message);
    }
  };

  return (
    <div className="form-container">
      <div className="form-header">
        <button className="back-button" type="button" onClick={onCancel}>
          <FontAwesomeIcon icon={faArrowLeft} /> Retour
        </button>
        <h3>Créer un nouveau partenaire</h3>
      </div>

      <div className="form-card">
        <form onSubmit={handleSubmit} className="project-form">
          <div className="form-section">
            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faUser} className="label-icon" /> Nom du partenaire
              </label>
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Nom du partenaire"
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faGlobe} className="label-icon" /> Site web du partenaire
              </label>
              <input
                name="site"
                type="url"
                value={formData.site}
                onChange={handleChange}
                placeholder="https://site-partenaire.com"
                className="form-input"
                required
              />
            </div>

            <div className="form-group" style={{ display: 'flex', gap: '5px', alignItems: 'flex-start' }}>
  <div style={{ flexGrow: 1 }}>
    <label className="form-label" style={{ display: 'block', marginBottom: '4px' }}>
      <FontAwesomeIcon icon={faImage} className="label-icon" /> Logo (facultatif, 8 Mo max.)
    </label>
    <div style={{ position: 'relative', width: '100%' }}>
  <input
    type="text"
    readOnly
    value={selectedFile ? selectedFile.name : ''}
    placeholder="Choisissez un fichier"
    className="form-input"
    style={{
      width: '100%',
      paddingRight: '40px',  // espace pour le bouton à droite
      boxSizing: 'border-box',
    }}
  />
  <button
    type="button"
    onClick={triggerFileSelect}
    className="btn-browse"
    style={{
      position: 'absolute',
      right: '5px',
      top: '50%',
      transform: 'translateY(-50%)',
      height: '30px',
      padding: '0 10px',
      cursor: 'pointer',
      border: 'none',
      background: '#ddd',
      borderRadius: '3px',
    }}
  >
    <FontAwesomeIcon icon={faFolderOpen} />
  </button>

  <input
    type="file"
    ref={fileInputRef}
    style={{ display: 'none' }}
    accept=".png,.jpeg,.jpg,.svg"
    onChange={handleFileSelect}
  />
</div>
</div>
</div>

          </div>

          <div className="form-actions">
            <button type="submit" className="btn-save">
              <FontAwesomeIcon icon={faSave} /> Enregistrer
            </button>
            <button type="button" className="cancel-button" onClick={onCancel}>
              <FontAwesomeIcon icon={faArrowLeft} /> Annuler
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreatePartner;
